import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  Grid,
  Card,
  CardContent,
  Stack,
} from "@mui/material";
import { Event, Email, QrCode, Timeline } from "@mui/icons-material";
import HeaderBar from "./widgets/HeaderBar";
import HomeContent from "./HomeContent";
import Footer from "./widgets/Footer";
import LayoutContainer from "./widgets/LayoutContainer";

export default function EventHome() {
  return (
    <LayoutContainer>
      <HomeContent />
    </LayoutContainer>
  );
}
